import { NavigationUrls } from '../constants/NavigationUrls'
import accepted from '../assets/images/newui/navbar/confirmed-sales.svg'
import acceptedActive from '../assets/images/newui/navbar/confirmed-sales-active.svg'
import invoice from '../assets/images/newui/navbar/invoice.svg'
import invoiceActive from '../assets/images/newui/navbar/invoice-active.svg'
import pricingActive from '../assets/images/newui/navbar/pricing-active.svg'
import pricing from '../assets/images/newui/navbar/pricing.svg'
import openReqActive from '../assets/images/newui/navbar/open-request-hover.svg'
import openReq from '../assets/images/newui/navbar/open-request.svg'

import accepted_new from '../assets/images/newui/navbarNew/confirmed-sales.svg'
import acceptedActive_new from '../assets/images/newui/navbarNew/confirmed-sales-active.svg'
import invoice_new from '../assets/images/newui/navbarNew/invoice.svg'
import invoiceActive_new from '../assets/images/newui/navbarNew/invoice-active.svg'
import pricingActive_new from '../assets/images/newui/navbarNew/pricing-active.svg'
import pricing_new from '../assets/images/newui/navbarNew/pricing.svg'
import openReqActive_new from '../assets/images/newui/navbarNew/open-request-hover.svg'
import openReq_new from '../assets/images/newui/navbarNew/open-request.svg'


export default [
    {
        path: "/",
        name: "Dashboard",
        icon: 'list',
        showInSideBar: true
    },
];